declare namespace $ {

	type $bog_theme_auto__theme_light_bog_smalljs_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_smalljs_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_theme_auto__themes_bog_smalljs_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $bog_smalljs_top__search_click_bog_smalljs_app_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['search_toggle'] >
		,
		ReturnType< $bog_smalljs_top['search_click'] >
	>
	type $bog_smalljs_top__Theme_bog_smalljs_app_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['Theme'] >
		,
		ReturnType< $bog_smalljs_top['Theme'] >
	>
	type $mol_view__dom_name_bog_smalljs_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_app_7 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['body_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_search__open_bog_smalljs_app_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['search_open'] >
		,
		ReturnType< $bog_smalljs_search['open'] >
	>
	type $bog_smalljs_search__anchor_key_bog_smalljs_app_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['docs_anchor_key'] >
		,
		ReturnType< $bog_smalljs_search['anchor_key'] >
	>
	type $bog_builderui_skin__lights_bog_smalljs_app_10 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['lights'] >
		,
		ReturnType< $bog_builderui_skin['lights'] >
	>
	type $bog_builderui_skin__base_bog_smalljs_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_skin['base'] >
	>
	type $bog_builderui_skin__chart_bog_smalljs_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_skin['chart'] >
	>
	type $bog_builderui_skin__font_head_bog_smalljs_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_skin['font_head'] >
	>
	type $bog_smalljs_versus_pair__left_bog_smalljs_app_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['versus_a'] >
		,
		ReturnType< $bog_smalljs_versus_pair['left'] >
	>
	type $bog_smalljs_versus_pair__right_bog_smalljs_app_15 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['versus_b'] >
		,
		ReturnType< $bog_smalljs_versus_pair['right'] >
	>
	type $bog_smalljs_versus_pair__lights_bog_smalljs_app_16 = $mol_type_enforce<
		ReturnType< $bog_smalljs_app['lights'] >
		,
		ReturnType< $bog_smalljs_versus_pair['lights'] >
	>
	export class $bog_smalljs_app extends $bog_builderui_div {
		dir( ): string
		hotkeys( ): any
		lang_sync( ): any
		route_canonical( ): any
		Theme( ): $bog_theme_auto
		Top( ): $bog_smalljs_top
		body_content( ): readonly(any)[]
		Body( ): $mol_view
		docs_anchor_key( ): string
		Search( ): $bog_smalljs_search
		Skin( ): $bog_builderui_skin
		versus_a( ): string
		versus_b( ): string
		section( next?: string ): string
		search_open( next?: boolean ): boolean
		search_toggle( next?: any ): any
		lights( ): string
		attr( ): ({ 
			'dir': ReturnType< $bog_smalljs_app['dir'] >,
		})  & ReturnType< $bog_builderui_div['attr'] >
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		plugins( ): readonly(any)[]
		Landing( ): $bog_smalljs_landing
		Docs( ): $bog_smalljs_docs
		Playground( ): $bog_smalljs_playground
		Course( ): $bog_smalljs_course
		Versus( ): $bog_smalljs_versus
		Pair( ): $bog_smalljs_versus_pair
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map